import T from 'i18n-react'
import * as R from 'ramda'
import {
  createSelectorWithPath,
  labelSelectorFunc,
  entitiesSelector,
  elementsSelector
} from 'helpers/ComponentSelectorUtil'

const valuesSelectorFunc = state => state.values ? state.values : []
const hintSelectorFunc = state => (state.defaultValue) ? T.translate(state.defaultValue) : ''
const getValuesSelector = (path, id) => createSelectorWithPath(
  `${path}.${id}`,
  (state) => R.map(R.prop('value'))(valuesSelectorFunc(state))
)

const getElementKeySelector = (id) => {
  return (state) => elementsSelector(state)[id].key
}

const getRowFormatSelector = (id) => {
  return (state) => {
    const element = elementsSelector(state)[id]
    const entities = entitiesSelector(state)

    let properties = element.values.items.properties
    delete properties.type

    properties = Object.fromEntries(
      Object.entries(properties).map((e) => {
        const [colKey, { ref }] = e
        
        if (ref) {
          const sources = Object.values(entities[ref]).map(({value}) => {
            return { value, label: value}
          })
          
          return [colKey, {
            type: 'drop_down',
            sources: sources
          }]
        }

        return e
      }
    ))

    return properties
  }
}

export {
  getValuesSelector,
  getElementKeySelector,
  getRowFormatSelector
}

export default (path) => {
  const withPath = createSelectorWithPath(path)
  const labelSelector = withPath(labelSelectorFunc)
  const valuesSelector = withPath(valuesSelectorFunc)
  const hintSelector = withPath(hintSelectorFunc)

  return {
    hintSelector,
    valuesSelector,
    labelSelector
  }
}